import http from '../../../service/axios';
import { FulfillmentMode } from '../../../store/slices/fulfillment';

export const checkoutAPI = {
  // The payment methods a branch offers depend on how the order is fulfilled,
  // so `order_type` is required by the backend, not optional.
  getPayment: async (branch_id: string, order_type: FulfillmentMode) =>
    http.get('/branch/payment-list', {
      params: {
        branch_id,
        company_id: 1,
        order_type,
        // Без этого флага онлайн-оплаты в выдаче нет вовсе — филиал отдаёт
        // только карту и наличные. С ним в списке появляется способ, по
        // которому бэкенд заводит платёж в Multicard и возвращает ссылку
        // вместе с заказом.
        multicard_payment: true,
      },
    }),
  maxAmout: async () => http.get('/branch/max-cash-amount'),
};
